<template>
    <v-app>
        <div
            :style='{
                "min-width": "100%",
                "min-height": "100%",
                "background-image":"url("+$url+"/images/logo-sf-bg.png"+")",
                "background-repeat":"repeat"
            }'
        >
            <encabezado
                :drawerNavega.sync="drawerNavega"
            />
            <navega
                :drawerNavega.sync="drawerNavega"
            />
                <login-window/>
            <div class='pt-7 mt-7 '>
                <v-main>
                    <v-container fluid>
                        <transition
                            name="fade"
                            mode="out-in"
                        >
                            <router-view/>
                        </transition>
                    </v-container>
                </v-main>
            </div>
        </div>
    </v-app>
</template>

<script>
import Encabezado from '@/components/Encabezado'
import Navega from '@/components/Navega'
import LoginWindows from '@/components/security/LoginWindow'
export default {
    name: 'App',
    mounted(){
        //console.log(require('/images/logo-sf-bg.png'))
    },
    components:{
        'encabezado': Encabezado,
        'navega':Navega,
        'login-window':LoginWindows,
    },

    data:()=>({
        drawerNavega:true,
        bgm: '@/images/logo-sf-bg.png'
    }),

    methods:{

    },
};
</script>
<style>
.fondo {
    min-width: 100%;
    min-height: 100%;
    background-image:url("http://localhost:8080/images/logo-sf-bg.png");
    background-repeat:repeat;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
